"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const QueryNameTextField_1 = __importDefault(require("../common/QueryNameTextField"));
const useQuerySelectValue_1 = require("../hooks/useQuerySelectValue");
const useRunQueryById_1 = require("../hooks/useRunQueryById");
const SelectQueryBuilder_1 = __importDefault(require("../query-builder/SelectQueryBuilder"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const SelectQueryBuilder2_1 = require("../query-builder/SelectQueryBuilder2");
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  .query-info {
    display: flex;
    padding: 12px 16px;
    border-bottom: solid 1px #ccc;
    .query-name-field {
      flex: 1;
      margin: 0 12px;
    }
  }
  .query-editor-split-pane {
    flex: 1;
  }
  .query-builder {
    padding: 12px 16px;
    overflow: auto;
  }
  .query-output-pane {
    overflow-y: auto;
    .column-header-cell {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      white-space: nowrap;
    }
    .column-entity-name {
      font-size: 10px;
      line-height: 10px;
      text-transform: uppercase;
      padding: 4px;
      background: #efefef;
      border-radius: 4px;
      width: min-content;
    }
    .column-name {
    }
  }
`;
const QueryEditPanel = () => {
    var _a, _b, _c, _d;
    const { plugins, queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const { queryData, runQuery } = (0, useRunQueryById_1.useRunQueryById)(((_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.id) || '');
    return (react_1.default.createElement(StyledDiv, { className: 'query-edit-panel' }, queryManager.query && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'query-info' },
            react_1.default.createElement(core_1.TextField, { select: true, variant: 'outlined', value: 'select', size: 'small' },
                react_1.default.createElement(core_1.MenuItem, { value: 'select' }, "SELECT")),
            react_1.default.createElement(QueryNameTextField_1.default, { className: 'query-name-field', query: queryManager.query, onChange: queryName => {
                    queryManager.updateName(queryName);
                } }),
            react_1.default.createElement(core_1.Button, { size: 'small', variant: 'contained', color: 'primary', onClick: () => runQuery() }, "Run")),
        react_1.default.createElement(core_ui_1.SplitPane, { className: 'query-editor-split-pane', direction: 'vertical' },
            react_1.default.createElement(core_ui_1.SplitPane, { className: 'query-builder' },
                react_1.default.createElement(core_1.Box, { mr: 2 },
                    react_1.default.createElement(SelectQueryBuilder2_1.SelectQueryBuilder2, { plugins: plugins, query: queryManager.query })),
                react_1.default.createElement(core_1.Box, { ml: 2 },
                    react_1.default.createElement(SelectQueryBuilder_1.default, null))),
            react_1.default.createElement(core_ui_1.Pane, { className: 'query-output-pane' },
                react_1.default.createElement(core_1.Toolbar, null,
                    "Output: ",
                    (queryData === null || queryData === void 0 ? void 0 : queryData.length) || 0,
                    " row(s)"),
                react_1.default.createElement(core_1.TableContainer, null,
                    react_1.default.createElement(core_1.Table, null,
                        react_1.default.createElement(core_1.TableHead, null,
                            react_1.default.createElement(core_1.TableRow, null, (_d = (_c = (_b = queryManager.query) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.selects) === null || _d === void 0 ? void 0 : _d.map((select, index) => {
                                var _a;
                                const columnMap = queryManager.queryAliasColumnMap.find(cm => cm.path === select.selection);
                                return (react_1.default.createElement(core_1.TableCell, { key: index },
                                    react_1.default.createElement("div", { className: 'column-header-cell' },
                                        (columnMap === null || columnMap === void 0 ? void 0 : columnMap.entity) && (react_1.default.createElement("span", { className: 'column-entity-name' }, columnMap.entity.displayName)),
                                        react_1.default.createElement("span", { className: 'column-name' }, ((_a = columnMap === null || columnMap === void 0 ? void 0 : columnMap.column) === null || _a === void 0 ? void 0 : _a.displayName) ||
                                            select.selection))));
                            }))),
                        react_1.default.createElement(core_1.TableBody, null, queryData === null || queryData === void 0 ? void 0 : queryData.map((item, index) => {
                            var _a, _b, _c;
                            return (react_1.default.createElement(core_1.TableRow, { key: index }, (_c = (_b = (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.selects) === null || _c === void 0 ? void 0 : _c.map((select, index) => {
                                var _a;
                                const value = (0, useQuerySelectValue_1.getQuerySelectValue)({
                                    item,
                                    select,
                                    expressionMap: (_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.config
                                });
                                // const targetTablePath =
                                //   trackChanges.final?.config?.joinAttributes?.find(
                                //     a => a.alias.name === alias
                                //   )?.alias.tablePath;
                                // const sourceTablePath = isRelation
                                //   ? trackChanges.final?.config?.joinAttributes?.find(
                                //       a => a.alias.name === alias
                                //     )?.alias.tablePath
                                //   : trackChanges.final?.config?.mainAlias
                                //       ?.tablePath;
                                // const sourceEntity = entities?.find(
                                //   e =>
                                //     sourceTablePath &&
                                //     e.tableName === sourceTablePath
                                // );
                                // const targetEntity = entities?.find(
                                //   e =>
                                //     targetTablePath &&
                                //     e.tableName === targetTablePath
                                // );
                                // const isOneToMany =
                                //   sourceEntity?.relations?.find(
                                //     r => r.propertyName === property
                                //   )?.type === RelationshipType.OneToMany;
                                return react_1.default.createElement(core_1.TableCell, { key: index }, value);
                            })));
                        }))))))))));
};
exports.default = QueryEditPanel;
//# sourceMappingURL=QueryEditPanel.js.map